import React from 'react';
import { createLabelHelper } from 'infrastructure/js/utils/labelHelper';
import Header, {headerItemsLabels} from '../../../Common/Header/header';
import KitTypesViewGrid from './KitTypesViewGrid/kitTypesViewGrid';
import {PL_DialogWrapper}  from 'infrastructure/js/components/Dialog/dialog';
import {MatSettingsMenuItemsIds} from '../../../../enums/navigationMenuItemsIds';
import PermissionManager from 'infrastructure/js/utils/permissionManager';
import {gridsNames} from '../../../../enums/gridsNames.js';
import {ImportAcceptFileTypes, ImportTypes} from '../../../../enums/importTypes';
import UpdateKitTypeVersionDialog from '../../../Dialogs/UpdateKitTypeVersionDialog/updateKitTypeVersionDialog';
import ImportFilesJsonDialog from '../../../Dialogs/ImportFilesJsonDialog/importFilesJsonDialog';

export default class KitTypesView extends React.PureComponent {

  constructor(props) {
    super(props);

    this.labels = createLabelHelper('mat.administration.matsettings.kittypes.view.');
  }

  componentDidMount() {
    this.props.actions.matSettingsPageActions.onSelectedMenuItemChanged(MatSettingsMenuItemsIds.NAV_ELEMENT_KIT_TYPES);
  }

  getHeaderItems() {
    let {actions} = this.props;
    let hasRows = this.props.sHasRows;
    let selectedRowsData = this.props.sSelectedRowsData;

    let items =  {
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        ...(PermissionManager.hasCreateOrEditKitTypesPermissions() ? [ //Note: show the buttons only for PS users
          {
            id:'create',
            label: headerItemsLabels.CREATE,
            icon: 'pl pl-icon-add',
            action: () => {
              this.props.history.push(`${this.props.match.url}/active/kitTypeForm`)
            },
          },
          {
            id:'edit',
            label: headerItemsLabels.EDIT,
            icon: 'pl pl-edit-icon',
            disabled: !(hasRows && selectedRowsData.size === 1),
            action: () => {
              this.props.history.push(`${this.props.match.url}/active/kitTypeForm/${selectedRowsData.get(0)?.id}/edit`)
            },
            actionData: selectedRowsData.get(0)
          },
        ] : []),
      ],
      kebab: {
        menuItems: [
          {
            id:'importKitTypes',
            label: headerItemsLabels.IMPORT_KIT_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_KIT_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id: 'importKitTypesJson',
            label: headerItemsLabels.IMPORT_KIT_TYPES_JSON,
            action: actions.header.onImportFilesJsonClick,
            actionData: {
              importType: ImportTypes.IMPORT_KIT_TYPES_JSON,
              acceptFileTypes: [ImportAcceptFileTypes.JSON],
              parentComponent: actions.reload
            }
          },
          {
            id:'importKitTypePlyTypes',
            label: headerItemsLabels.IMPORT_PLIES_TO_KIT_TYPES,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_KIT_TYPE_PLY_TYPES],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id:'exportKitTypes',
            label: headerItemsLabels.EXPORT_KIT_TYPES,
            action: actions.header.exportItems,
            disabled: !hasRows,
            actionData: {gridName: gridsNames.ADMINISTRATION_MAT_SETTINGS_KIT_TYPES}
          },
          {
            id:'remove',
            label: headerItemsLabels.DELETE,
            action: actions.header.onRemoveKitTypesClick,
            disabled: (!selectedRowsData || selectedRowsData.size === 0),
            actionData:  selectedRowsData,
          },
          {
            id:'importOperationSequence',
            label: headerItemsLabels.IMPORT_OPERATION_SEQUENCE,
            action: actions.header.importItems,
            disabled: false,
            actionData: {
              importTypes: [ImportTypes.IMPORT_OPERATION_SEQUENCE],
              acceptFileTypes: [ImportAcceptFileTypes.CSV],
              parentComponent: actions.reload
            }
          },
          {
            id:'exportOperationSequence',
            label: headerItemsLabels.EXPORT_OPERATION_SEQUENCE,
            action: actions.header.exportOperationSequence,
            disabled: !hasRows,
            actionData: {}
          },
          {
            id:'clone',
            label: headerItemsLabels.CLONE,
            action: () => this.props.history.push(`${this.props.match.url}/active/kitTypeForm/${selectedRowsData.get(0)?.id}/clone`),
            disabled:  !(hasRows && selectedRowsData.size === 1),
            actionData:  selectedRowsData.get(0)
          },

        ]
      }
    };

    return items;
  }

  reloadPage = () => {
    this.props.actions.init(true);
  };

  render() {
    let headerItems = this.getHeaderItems();
    return (
      <div className="administration-view">
        <Header {...headerItems} />
        <KitTypesViewGrid gridName={gridsNames.ADMINISTRATION_MAT_SETTINGS_KIT_TYPES}
                          actions={{...this.props.actions.kitTypesViewGridActions, ...this.props.actions.fetchEntitiesActions}}/>

        <PL_DialogWrapper
                          dialogComponent={ImportFilesJsonDialog}
                          show={this.props.sImportFilesJsonDialogData.get("show")}
                          actions={this.props.actions.importFilesJsonDialogActions}
                          sData={this.props.sImportFilesJsonDialogData}
                          reloadParentComponent={this.reloadPage}
        />

        <PL_DialogWrapper dialogComponent={UpdateKitTypeVersionDialog}
                          show={this.props.sUpdateKitTypeVersionDialogData.get('show')}
                          actions={this.props.actions.updateKitTypeVersionDialogActions}
                          sData={this.props.sUpdateKitTypeVersionDialogData}
                          sGrid={this.props.sUpdateKitTypeVersionGrid}
                          reloadParentComponent={this.reloadPage}
        />
      </div>
    );
  }
}
